import React from "react"
import { Spin } from "antd"
import { Waypoint } from "react-waypoint"
import PropTypes from "prop-types"
import EmbeddedExperienceCard from "../../../../Embedded/ExperienceCard/index"
import { getExperienceMainPhoto } from "../../utils/getExperienceMainPhoto"
import { isLastPage } from "helpers/pagination"
import styles from "./index.module.css"

const ExperienceGrid = ({ experiences, guuid, loading, hasMore, onLoadMore, metadata, scrollableAncestor }) => {
  const lastPage = isLastPage(metadata)
  const shouldShowWaypoint = !lastPage && hasMore

  return (
    <>
      <div className={styles.gridContainer}>
        {experiences?.map((exp, index) => {
          const mainPhotoUrl = getExperienceMainPhoto(exp)

          return (
            <div key={exp?.uuid || index} className={styles.gridItem}>
              <EmbeddedExperienceCard
                image={mainPhotoUrl}
                title={exp?.title}
                location={exp?.address}
                time={exp?.available_hours_range}
                people={exp?.max_guests}
                price={exp?.min_price}
                experienceId={exp?.uuid}
                showFavoriteButton={true}
                favorite={exp?.is_favorite}
                mode="guideProfile"
                guuid={guuid}
              />
            </div>
          )
        })}
      </div>

      {shouldShowWaypoint && (
        <Waypoint
          onEnter={onLoadMore}
          scrollableAncestor={scrollableAncestor}
          bottomOffset="-200px"
        />
      )}

      {loading && (
        <div className={styles.loadingContainer}>
          <Spin size="large" />
        </div>
      )}
    </>
  )
}

ExperienceGrid.propTypes = {
  experiences: PropTypes.arrayOf(PropTypes.object).isRequired,
  guuid: PropTypes.string,
  loading: PropTypes.bool,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  metadata: PropTypes.object,
  scrollableAncestor: PropTypes.object
}

ExperienceGrid.defaultProps = {
  loading: false,
  hasMore: true,
  guuid: null,
  metadata: null,
  scrollableAncestor: null
}

export default ExperienceGrid
